import { ROLES } from "../common/Const";
import { normalizeLessonRegisterStudents } from "./lessonRegisterStudents";
import { ATTENDANCE_STATUS } from "./lessonAttendanceStatus";
import { canEditLessonAttendance } from "./lessonCommandPermissions";

export const buildTeacherLessonRegisterPayload = (lesson, lessonDetailsEx, studentsEx) => {
  const id = lesson.lessonRegister ? { id: lesson.lessonRegister.id } : {};
  return {
    ...id,
    lessonId: lesson.id,
    lessonDetails: {
      comment: lessonDetailsEx.comment || "",
    },
    students: normalizeLessonRegisterStudents(studentsEx).map(student => ({
      id: student.id,
      isPresent: student.isPresent,
    })),
  };
};

export const getOriginalLessonStudents = lesson => (
  lesson.lessonRegister
    ? lesson.lessonRegister.students
    : lesson.defaultStudents.map(s => ({ id: s.id, isPresent: false }))
);

const LESSON_DETAILS_PAYLOAD_FIELDS = [
  "date",
  "dayOfWeek",
  "startTime",
  "teacherId",
  "classTypeId",
  "isRecurring",
  "comment",
  "attendanceStatus",
  "lessonStatus",
  "lessonCancellation",
  "cancellationSummary",
];

export const buildLessonDetailsPayload = (lessonDetails = {}) => (
  LESSON_DETAILS_PAYLOAD_FIELDS.reduce((payload, field) => {
    if (Object.prototype.hasOwnProperty.call(lessonDetails, field)) {
      return {
        ...payload,
        [field]: lessonDetails[field],
      };
    }
    return payload;
  }, {})
);

export const buildLessonRegisterPayload = ({
  lesson,
  lessonDetailsEx,
  studentsEx,
  role,
  userTeacherId,
}) => {
  const canEditAttendance = canEditLessonAttendance(role, userTeacherId, lessonDetailsEx);

  if (!canEditAttendance && !lesson.lessonRegister) {
    return null;
  }

  const id = lesson.lessonRegister ? { id: lesson.lessonRegister.id } : {};
  const studentsToSave = canEditAttendance ? studentsEx : getOriginalLessonStudents(lesson);
  const lessonDetailsToSave = buildLessonDetailsPayload(lessonDetailsEx);

  return role === ROLES.TEACHER
    ? buildTeacherLessonRegisterPayload(lesson, lessonDetailsEx, studentsToSave)
    : {
      ...id,
      lessonId: lesson.id,
      lessonDetails: {
        ...lessonDetailsToSave,
        attendanceStatus: ATTENDANCE_STATUS.CHECKED,
      },
      students: normalizeLessonRegisterStudents(studentsToSave),
    };
};

export const buildLessonRegisterCommandBasePayload = ({
  lesson,
  lessonDetailsEx,
  studentsEx,
}) => ({
  ...(lesson.lessonRegister ? { id: lesson.lessonRegister.id } : {}),
  lessonId: lesson.id,
  lessonDetails: {
    ...buildLessonDetailsPayload(lessonDetailsEx),
    attendanceStatus: (lessonDetailsEx || {}).attendanceStatus || ATTENDANCE_STATUS.NOT_CHECKED,
    lessonStatus: (lessonDetailsEx || {}).lessonStatus || "scheduled",
  },
  students: normalizeLessonRegisterStudents(studentsEx),
});
